module.exports = __webpack_public_path__ + "media/checkout_application_v3/assets/images/flag_fi_finnish-aed885cc7a38b534b2b69bc5ca939979.svg";